import React from 'react';
import { Box, ColumnLayout } from '@amzn/awsui-components-react/polaris';

/**
 * Standard header row for a Segment Data Tables page: an `h2` title on the left and right-aligned
 * actions. Shared by the list tab (title = "Segment Data Tables (n)", actions = Create) and the detail
 * data-viewer (title = the table name, actions = the toolbar). Matches the existing list markup so the
 * two surfaces stay visually consistent.
 */
export default function SegmentPageHeader(props: { title: React.ReactNode; actions?: React.ReactNode }) {
    const { title, actions } = props;
    return (
        <div className="customTableTableHeader">
            <ColumnLayout columns={2} data-class="fullColumnLayout">
                <Box variant="h2">{title}</Box>
                <Box float="right">{actions}</Box>
            </ColumnLayout>
        </div>
    );
}
